import { Fragment, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import ButtomButton from "../../DocButtomButton";
import CustomInput from "../../CustomInput";
import { createAnnouncement } from "../../../actions/announcement.action";
import ErrorInputComponent from "../../ErrorInputComponent";
import { Loading } from "../../../utils/helpers/constants";
import ImageUploadComponent from "../../ImageUploadComponent";
import { imageValidator } from "../../../utils/helpers/dataHelper";
import TextEditor from "./TextEditor";

export default function CreateAnnouncementModal({
  open,
  setOpen,
  cancelButtonRef,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [description, setDescription] = useState("");
  const [imageError, setImageError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [imageDetails, setImageDetails] = useState({
    imagePreview: "",
    file: "",
  });

  const {
    announcement: { announcementLoading },
  } = useSelector(({ announcementReducer }) => ({
    announcement: announcementReducer,
  }));

  const onImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageError("");
      let reader = new FileReader();
      let file = event.target.files[0];
      let isValid = imageValidator(file);
      if (isValid) {
        reader.onloadend = () => {
          setImageDetails({
            ...imageDetails,
            imagePreview: reader.result,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    // description: Yup.string().required("Description type is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      title: "",
      description: "",
    },
    validationSchema,
    onSubmit(values) {
      const payload = {
        title: values.title,
        description: description,
      };
      const reload = () => history.go(0);
      var formDataPayload = convertJSONToFormData(payload);
      const imageFile = imageDetails.file;
      if (description === "") {
        setDescriptionError("Description type is required");
      } else {
        setDescriptionError("");
      }
      if (imageFile === "") {
        setImageError("Image is required");
      } else {
        dispatch(createAnnouncement(formDataPayload, reload));
      }
    },
  });

  const convertJSONToFormData = (payload) => {
    const stringRequest = JSON.stringify(payload);
    const blobRequest = new Blob([stringRequest], {
      type: "application/json",
    });
    const formData = new FormData();
    formData.append("imageFile", imageDetails.file);
    formData.append("request", blobRequest);

    return formData;
  };

  const buttonLoadState = announcementLoading === Loading.FETCHING;

  console.log({ description });

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-cente overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => setOpen(false)}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            Create Announcement
                          </div>
                        </div>
                      </div>
                      <div className="mt-10 sm:px-6 px-6 w-full">
                        <form>
                          <CustomInput
                            handleChange={handleChange}
                            name="title"
                            placeholder="Title"
                          />
                          <ErrorInputComponent error={errors.title} />
                          <TextEditor setValue={setDescription} />
                          <ErrorInputComponent error={descriptionError} />

                          <ImageUploadComponent
                            onImageUpload={(e) => onImageUpload(e)}
                            imageDetails={imageDetails}
                            imageError={imageError}
                          />
                        </form>
                      </div>
                      <ButtomButton
                        name={"Proceed"}
                        func={handleSubmit}
                        loading={buttonLoadState}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
